import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

// Corporate program card — cleaner, lighter, HR-director friendly.
export const CorporateCard = ({ program, index, icon: Icon, className = "" }) => (
  <motion.article
    whileHover={{ y: -4 }}
    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
    className={cn(
      "group relative flex flex-col rounded-2xl border border-legacy-charcoal/10 bg-white p-7 md:p-8 transition-colors duration-500 hover:border-legacy-gold/60",
      className
    )}
    data-testid={`corporate-card-${program.id}`}
  >
    <div className="flex items-center justify-between">
      {Icon ? (
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-legacy-softmint text-legacy-charcoal">
          <Icon className="h-6 w-6" aria-hidden="true" />
        </span>
      ) : (
        <span className="font-heading text-4xl text-legacy-charcoal/15">
          {String(index + 1).padStart(2, "0")}
        </span>
      )}
    </div>
    <h3 className="mt-6 font-heading text-2xl text-legacy-charcoal">
      {program.title}
    </h3>
    <p className="mt-3 text-sm md:text-base leading-relaxed text-legacy-charcoal/70">
      {program.description}
    </p>
  </motion.article>
);
